import VeiculoTransportadora from "@/models/veiculoTransportadora";
import { VeiculoTransportadoraAPI, PaginateVeiculoTransportadora } from "@/api/sit-pedidos/veiculo-transportadora.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";

const api = new VeiculoTransportadoraAPI();

const list = (
  paginate: PaginateVeiculoTransportadora
): AxiosObservable<VeiculoTransportadora[]> => {
  return api.list(paginate)
};

const listExcludes = (
  paginate: PaginateVeiculoTransportadora
): AxiosObservable<VeiculoTransportadora[]> => {
  return api.listExcludes(paginate)
};

export default { list, listExcludes };
